import { ContentfulComponentCardDeck } from 'graphqlTypes';
import { FC } from 'react';

import Flex from 'quarks/Flex';

import MinimalCard from 'components/CardDeck/MinimalCardDeck/MinimalCard';

interface MinimalCardDeckStaticProps extends ContentfulComponentCardDeck {
  backgroundIsDark?: boolean;
}

const MinimalCardDeckStatic: FC<MinimalCardDeckStaticProps> = ({ card: cards }) => (
  <Flex data-testid="card-body" flexDirection="row" flexWrap="wrap" overflowX="hidden" overflowY="hidden">
    {cards && cards.map((card, index) => <MinimalCard card={card} key={`card-${index}`} />)}
  </Flex>
);

export default MinimalCardDeckStatic;
